import { render, staticRenderFns } from "./BloqueList.vue?vue&type=template&id=0e7c6289&scoped=true&"
import script from "./BloqueList.vue?vue&type=script&lang=js&"
export * from "./BloqueList.vue?vue&type=script&lang=js&"
import style0 from "./BloqueList.vue?vue&type=style&index=0&id=0e7c6289&lang=scss&scoped=true&"
import style1 from "./BloqueList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7c6289",
  null
  
)

export default component.exports